import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { pageLoginText } from "../../lib/constants";
import { LoginForm } from "./LoginForm";

export const LoginContainer = ({ onShowModal }) => {
  return (
    <Container className="login-container">
          <Row className="justify-content-center align-items-center align-center login-row">
            <Col>
                <Card>
                  <Card.Body className="login-card-body">
                      <Card.Title as="h5" className="login-title">
                        {pageLoginText.card_title} <strong>{pageLoginText.card_title_black}</strong>
                      </Card.Title>
                      <p className="login-description">{pageLoginText.card_text}</p>
                      <LoginForm onShowModal={onShowModal} />
                  </Card.Body>
                </Card>
            </Col>
          </Row>
    </Container>
  );
};